import React from 'react';
import styled from 'styled-components';
import { FontSize14 } from '../fonts';
import { TextBlock, BaseText, TextAlignCenter } from '../text';
import { MarginTop20 } from '../margins';

const Text = styled(TextBlock)`
    ${FontSize14};
    ${TextAlignCenter};
    ${MarginTop20};
`;

const Link = styled.span`
    ${BaseText};
    ${FontSize14};
    text-decoration: underline;
    &:hover {
        cursor: pointer;
    }
`;

export const SaveAndContinueLater = ({ onClick }) => (
    <Text>
        Oppure <Link onClick={onClick}>salva e continua dopo</Link>
    </Text>
);